import * as partnerChildrenFormSchema from 'schemas/forms/PartnerChildrenForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
// import moment from 'moment'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import DateInput from 'components/Form/components/DateInput'
import styles from './PartnerChildrenDisplayForm.scss'
import { format, parse } from 'date-fns'
import constants from 'constants'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class PartnerChildrenDisplayForm extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hasFetched: PropTypes.bool,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    personalInfo: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }

  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    hasFetched: false,
    id: '',
    title: '',
    description: '',
    handleFormSubmit: null,
  }

  componentWillMount() {
    const { formFields } = partnerChildrenFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const { personalInfo } = nextProps

    const modalCreated = this.props.modals.partnerChildrenForm
    const modalChanged = modalCreated && nextProps.modals.partnerChildrenForm.show !== this.props.modals.partnerChildrenForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.partnerChildrenForm.show
    const modalVisible = modalCreated && nextProps.modals.partnerChildrenForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (nextProps.personalInfo !== this.props.personalInfo) {
      this.data = nextProps.personalInfo
    }

    if (modalChanged && modalVisible && nextProps.personalInfo.selectedPartnerChildren !== this.props.personalInfo.selectedPartnerChildren) {
      // preload data from BED if needed
      // if (personalInfo.selectedPartnerChildren.children_id) {
      const dateOfBirth = (personalInfo.selectedPartnerChildren.date_of_birth ?
        format(parse(personalInfo.selectedPartnerChildren.date_of_birth, constants.DATE_FORMAT.STANDARD_ISO_TIME, new Date()), constants.DATE_FORMAT.STANDARD_AU_NOTIME) : '')

      this._handleChange('children_id', personalInfo.selectedPartnerChildren.children_id)
      this._handleChange('full_name', personalInfo.selectedPartnerChildren.full_name)
      this._handleChange('date_of_birth', (personalInfo.selectedPartnerChildren.date_of_birth ? dateOfBirth : ''))
      // }
    }
  }

  _schema = () => {
    const obj = {}
    partnerChildrenFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (!key.startsWith('_')) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(partnerChildrenFormSchema.requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(data)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return form.full_name.value && form.date_of_birth.value
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      // frequencies,
      // groupsAndEntities,
      modals,
      // serviceTypes,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    // const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="partnerChildrenForm"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <fieldset>
              <ul>
                <li>
                  <TextInput
                    {...schema.children_id}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.children_id.value}
                  />
                  <TextInput
                    {...schema.full_name}
                    error={form.full_name.error}
                    focus={form.full_name.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.full_name.value}
                    valid={form.full_name.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.date_of_birth}
                    error={form.date_of_birth.error}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.date_of_birth.value}
                    valid={form.date_of_birth.valid}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                isLarge
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default PartnerChildrenDisplayForm



// WEBPACK FOOTER //
// ./src/views/PersonalInfo/PartnerChildrenDisplayForm.js